module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-sign-contract"
  }, [_c('h2', [_vm._v(_vm._s(_vm.renew_contract ? '续签合同' : '新签合同') + " " + _vm._s(_vm.by_day ? '(日租)' : ''))]), (!_vm.renew_contract && !_vm.preorder && !_vm.by_day) ? _c('div', {
    staticClass: "ui button yellow",
    on: {
      "click": function($event) {
        _vm.init_by_day()
      }
    }
  }, [_vm._v("转换为日租合同")]) : _vm._e(), (_vm.current_contract && !_vm.current_contract.preorderable && _vm.current_contract_days_to_end > 0) ? _c('div', {
    staticClass: "ui icon warning message"
  }, [_c('i', {
    staticClass: "warning icon"
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("当前合同未到期")]), _c('p', [_vm._v("距离当前合同到期还有 " + _vm._s(_vm.current_contract_days_to_end) + " 天 (" + _vm._s(_vm.$formatters.date.to_date(_vm.current_contract.date_end)) + ")， 请核对信息确认无误后继续操作。")])])]) : _vm._e(), (_vm.preorder) ? [_c('h3', [_vm._v("预约信息")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.preorder,
      "data": [_vm.preorder],
      "detail-view": true,
      "layout": "detailed_table"
    }
  })] : _vm._e(), (_vm.renew_contract) ? [_c('h3', [_vm._v("原合同信息")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.contract,
      "unstackable": "unstackable",
      "data": [_vm.renew_contract],
      "detail-view": true
    }
  })] : _vm._e(), _c('h3', [_vm._v("合同信息")]), _c('el-form', {
    ref: "formContract",
    staticClass: "ui form",
    attrs: {
      "model": _vm.draft.contract,
      "rules": _vm.rules.contract
    }
  }, [_c('div', {
    staticClass: "equal width fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_start"
    }
  }, [_c('label', [_vm._v("开始日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "placeholder": "开始日期",
      "disabled": !!this.renew_contract
    },
    model: {
      value: (_vm.draft.contract.date_start),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "date_start", $$v)
      },
      expression: "draft.contract.date_start"
    }
  })], 1), (!_vm.by_day) ? _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "duration_months"
    }
  }, [_c('label', [_vm._v("合同时长 (月)")]), _c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.draft.contract.duration_months),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "duration_months", $$v)
      },
      expression: "draft.contract.duration_months"
    }
  })], 1) : _vm._e(), (_vm.by_day) ? _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "duration_days"
    }
  }, [_c('label', [_vm._v("合同时长 (日)")]), _c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.draft.contract.duration_days),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "duration_days", $$v)
      },
      expression: "draft.contract.duration_days"
    }
  })], 1) : _vm._e(), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_end"
    }
  }, [_c('label', [_vm._v("结束日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "placeholder": "结束日期",
      "min": _vm.draft.contract.date_start
    },
    model: {
      value: (_vm.draft.contract.date_end),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "date_end", $$v)
      },
      expression: "draft.contract.date_end"
    }
  })], 1)], 1), _c('div', {
    staticClass: "equal width fields"
  }, [(!_vm.by_day) ? _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "pay_unit_month"
    }
  }, [_c('label', [_vm._v("租金支付单位 (月)")]), _c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.draft.contract.pay_unit_month),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "pay_unit_month", $$v)
      },
      expression: "draft.contract.pay_unit_month"
    }
  })], 1) : _vm._e(), (!_vm.by_day) ? _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "price_month"
    }
  }, [_c('label', [_vm._v("租金 / 月")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.draft.contract.price_month),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "price_month", $$v)
      },
      expression: "draft.contract.price_month"
    }
  })], 1) : _vm._e(), (_vm.by_day) ? _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "price_day"
    }
  }, [_c('label', [_vm._v("租金 / 日")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.draft.contract.price_day),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "price_day", $$v)
      },
      expression: "draft.contract.price_day"
    }
  })], 1) : _vm._e(), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "deposit_money"
    }
  }, [_c('label', [_vm._v("合同押金")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false,
      "disabled": _vm.renew_contract
    },
    model: {
      value: (_vm.draft.contract.deposit_money),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "deposit_money", $$v)
      },
      expression: "draft.contract.deposit_money"
    }
  })], 1), (!_vm.by_day) ? [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "management_fee_month"
    }
  }, [_c('label', [_vm._v("管理费 / 月")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.draft.contract.management_fee_month),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "management_fee_month", $$v)
      },
      expression: "draft.contract.management_fee_month"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "network_fee_month"
    }
  }, [_c('label', [_vm._v("网络费 / 月")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.draft.contract.network_fee_month),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "network_fee_month", $$v)
      },
      expression: "draft.contract.network_fee_month"
    }
  })], 1)] : [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "cleaning_fee"
    }
  }, [_c('label', [_vm._v("清洁费")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.draft.contract.cleaning_fee),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "cleaning_fee", $$v)
      },
      expression: "draft.contract.cleaning_fee"
    }
  })], 1)]], 2)]), _c('h3', [_vm._v("首期租金")]), _c('el-form', {
    ref: "formRent",
    staticClass: "ui form",
    attrs: {
      "model": _vm.draft.rent,
      "rules": _vm.rules.rent
    }
  }, [_c('div', {
    staticClass: "equal width fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required"
  }, [_c('label', [_vm._v("租金开始日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "placeholder": "开始日期",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.draft.contract.date_start),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "date_start", $$v)
      },
      expression: "draft.contract.date_start"
    }
  })], 1), (!_vm.by_day) ? _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "rent_month"
    }
  }, [_c('label', [_vm._v("时长 (月)")]), _c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.draft.rent.rent_month),
      callback: function($$v) {
        _vm.$set(_vm.draft.rent, "rent_month", $$v)
      },
      expression: "draft.rent.rent_month"
    }
  })], 1) : _vm._e(), (_vm.by_day) ? _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "rent_day"
    }
  }, [_c('label', [_vm._v("时长 (日)")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": "disabled"
    },
    model: {
      value: (_vm.draft.rent.rent_day),
      callback: function($$v) {
        _vm.$set(_vm.draft.rent, "rent_day", $$v)
      },
      expression: "draft.rent.rent_day"
    }
  })], 1) : _vm._e(), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_end"
    }
  }, [_c('label', [_vm._v("租金结束日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "placeholder": "结束日期",
      "disabled": _vm.by_day
    },
    model: {
      value: (_vm.draft.rent.date_end),
      callback: function($$v) {
        _vm.$set(_vm.draft.rent, "date_end", $$v)
      },
      expression: "draft.rent.date_end"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "amount_paid"
    }
  }, [_c('label', [_vm._v("租金总额")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.draft.rent.amount_paid),
      callback: function($$v) {
        _vm.$set(_vm.draft.rent, "amount_paid", $$v)
      },
      expression: "draft.rent.amount_paid"
    }
  })], 1)], 1)]), (_vm.$permission.has("basic.create.contracts.discount") && !_vm.by_day) ? [_c('h3', [_vm._v("优惠策略")]), _c('div', {
    staticClass: "ui field"
  }, [_c('div', {
    staticClass: "ui button orange",
    on: {
      "click": _vm.discount_management
    }
  }, [_vm._v("免除1个月管理费")]), _c('div', {
    staticClass: "ui button orange",
    on: {
      "click": _vm.discount_rent
    }
  }, [_vm._v("免除1个月租金")]), _c('div', {
    staticClass: "ui button grey",
    on: {
      "click": _vm.discount_reset
    }
  }, [_vm._v("重置优惠")])])] : _vm._e(), _c('h3', [_vm._v("住户信息")]), _c('div', {
    staticClass: "ui field"
  }, [_c('form-customers', {
    ref: "customers",
    attrs: {
      "customers": _vm.draft.customers
    }
  })], 1), _c('h3', [_vm._v("其他")]), _c('el-form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("其他费用")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft.contract.other_fee_note),
      expression: "draft.contract.other_fee_note"
    }],
    domProps: {
      "value": (_vm.draft.contract.other_fee_note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.draft.contract, "other_fee_note", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("其他费用金额")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "controls": false
    },
    model: {
      value: (_vm.draft.contract.other_fee),
      callback: function($$v) {
        _vm.$set(_vm.draft.contract, "other_fee", $$v)
      },
      expression: "draft.contract.other_fee"
    }
  })], 1)]), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("合同补充")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft.contract.additions),
      expression: "draft.contract.additions"
    }],
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.draft.contract.additions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.draft.contract, "additions", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("备注")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.draft.contract.note),
      expression: "draft.contract.note"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.draft.contract.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.draft.contract, "note", $event.target.value)
      }
    }
  })])]), _c('h3'), (!this.renew_contract) ? _c('div', {
    staticClass: "ui grid two columns stackable"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "with-actions"
  }, [_c('span', [_vm._v("物品清单")]), _c('div', {
    staticClass: "ui buttons actions"
  }, [_c('div', {
    staticClass: "ui basic icon button",
    on: {
      "click": function($event) {
        _vm.dialog_properties = true
      }
    }
  }, [_c('i', {
    staticClass: "icon pencil themed text"
  })]), _c('div', {
    staticClass: "ui basic icon button",
    on: {
      "click": _vm.print_properties
    }
  }, [_c('i', {
    staticClass: "icon print themed text"
  })])])]), _c('room-properties', {
    attrs: {
      "properties": _vm.draft.properties
    }
  }), _c('dialog-edit-properties', {
    attrs: {
      "properties": _vm.draft.properties,
      "visible": _vm.dialog_properties
    },
    on: {
      "update:properties": function($event) {
        _vm.$set(_vm.draft, "properties", $event)
      },
      "update:visible": function($event) {
        _vm.dialog_properties = $event
      },
      "exit": function($event) {
        _vm.dialog_properties = false
      }
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [(!_vm.$config.logic.manual_meter) ? _c('el-checkbox', {
    attrs: {
      "label": "预充值水电费"
    },
    model: {
      value: (_vm.draft.pay_for_utilities),
      callback: function($$v) {
        _vm.$set(_vm.draft, "pay_for_utilities", $$v)
      },
      expression: "draft.pay_for_utilities"
    }
  }) : _vm._e(), _c('br'), _c('br'), _c('h3', {
    staticClass: "with-actions"
  }, [_c('span', [_vm._v("水电表信息")]), _c('div', {
    staticClass: "actions ui tiny buttons"
  }, [_c('div', {
    staticClass: "ui basic button icon",
    on: {
      "click": function($event) {
        _vm.dialog_utilities = true
      }
    }
  }, [_c('i', {
    staticClass: "pencil icon themed text"
  })])])]), _vm._l((_vm.room.utilities), function(utility, index) {
    return _c('utility-view', {
      key: index,
      attrs: {
        "paid": _vm.room.utilities_paid,
        "data": utility
      }
    })
  }), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog_utilities,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_utilities = $event
      }
    }
  }, [(_vm.dialog_utilities) ? [_c('form-utilities', {
    attrs: {
      "no": _vm.no,
      "indialog": true
    },
    on: {
      "exit": function($event) {
        _vm.dialog_utilities = false
      }
    }
  })] : _vm._e()], 2)], 2)]) : _vm._e(), _c('h3', [_vm._v("费用清单")]), _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('receipts', {
    attrs: {
      "receipts": _vm.receipts
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("支付方式")]), _c('payment-method-select', {
    model: {
      value: (_vm.draft.payment_method),
      callback: function($$v) {
        _vm.$set(_vm.draft, "payment_method", $$v)
      },
      expression: "draft.payment_method"
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('br'), _c('el-checkbox', {
    staticClass: "inline",
    model: {
      value: (_vm.if_print_properties),
      callback: function($$v) {
        _vm.if_print_properties = $$v
      },
      expression: "if_print_properties"
    }
  }, [_vm._v("生成物品清单")]), (_vm.draft.pay_for_utilities) ? _c('el-checkbox', {
    staticClass: "inline",
    model: {
      value: (_vm.if_print_utilities),
      callback: function($$v) {
        _vm.if_print_utilities = $$v
      },
      expression: "if_print_utilities"
    }
  }, [_vm._v("生成水电费单")]) : _vm._e()], 1), _c('div', {
    staticClass: "ui field actions"
  }, [(_vm.$permission.has("basic.create.contract.print_ahead") && false) ? [(_vm.draft.pay_for_utilities) ? _c('div', {
    staticClass: "ui button icon labeled blue",
    on: {
      "click": _vm.print_utilities
    }
  }, [_c('i', {
    staticClass: "icon print"
  }), _vm._v("生成水电费单")]) : _vm._e(), _c('div', {
    staticClass: "ui button icon labeled blue",
    on: {
      "click": _vm.print_properties
    }
  }, [_c('i', {
    staticClass: "icon print"
  }), _vm._v("生成物品清单")]), _c('div', {
    staticClass: "ui button icon labeled teal",
    on: {
      "click": _vm.print_draft
    }
  }, [_c('i', {
    staticClass: "icon print"
  }), _vm._v("生成合同")])] : _vm._e(), _c('div', {
    staticClass: "ui button themed icon labeled",
    on: {
      "click": _vm.stage_finish
    }
  }, [_c('i', {
    staticClass: "icon checkmark"
  }), _vm._v("完成签署")]), _c('div', {
    staticClass: "ui button icon",
    on: {
      "click": _vm.draft_save
    }
  }, [_c('i', {
    staticClass: "icon save"
  })]), _c('div', {
    staticClass: "ui button icon",
    on: {
      "click": _vm.draft_remove
    }
  }, [_c('i', {
    staticClass: "icon trash"
  })])], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a704a192","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormSignContract.vue
// module id = 410
// module chunks = 0